export default __webpack_public_path__ + "static/media/placeholder-2.fd8d79d5.png";